import type { IntersectingDocOption } from "building-types/options/intersectingOptionSet";
import type { IntersectionEffect, modifiableFields } from "building-types/options/intersectionBaseTypes";
import type { DocOption } from "building-types/options/optionSet";
import type { Multimap } from "common/data/multimap";

export interface ActiveIntersectionEffect extends IntersectingDocOption {
  effect: IntersectionEffect;
}

export interface SegmentedIntersectionEffects {
  modify: Multimap<ActiveIntersectionEffect>;
  generate: ActiveIntersectionEffect[];
}

export function intersectionModifiesField(field: keyof DocOption) {
  return (intersection: ActiveIntersectionEffect): boolean => {
    return (
      intersection.effect.type === "MODIFY" &&
      !!intersection.effect.modifySettings?.fields?.includes(field as (typeof modifiableFields)[number]) &&
      intersection.option[field] !== undefined
    );
  };
}
